<ng-container *transloco="let t">
    <h2 mat-dialog-title>
        {{ t("application.dialogs." + data.step + ".title") }}
    </h2>
    <mat-dialog-content class="mat-typography">
        <p>{{ t("application.dialogs." + data.step + ".content") }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>
            {{ t("application.dialogs.actions.cancel") }}
        </button>
        <button mat-button [mat-dialog-close]="true">
            {{ t("application.dialogs." + data.step + ".button") }}
        </button>
    </mat-dialog-actions>
</ng-container>
